export const FILTER_OPTIONS_ALL = [
    { label: 'ALL WINDOWS', value: 'ALL' },
    { label: 'APPROVED WINDOWS', value: 'APPROVED' },
    { label: 'MY PENDING WINDOWS', value: 'MY_PENGING' },
    // { label: 'MY REJECTED WINDOWS', value: 'MY_REJECTED' },
    { label: 'OTHERS', value: 'OTHERS' }
];

export const FILTER_OPTIONS_MY = [
    { label: 'ALL MY WINDOWS', value: 'ALL' },
    { label: 'MY APPROVED WINDOWS', value: 'MY_APPROVED' },
    { label: 'MY PENDING WINDOWS', value: 'MY_PENGING' },
    { label: 'MY REJECTED WINDOWS', value: 'MY_REJECTED' },
    { label: 'MY CANCELED WINDOWS', value: 'MY_CANCELED' }
];